//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

//* Types imports
import type { ISaleOutputDTO, ValidateSaleTokenInput } from "@/schemas/sales";

async function validateSaleToken(data: ValidateSaleTokenInput) {
  const response = await fetch(`${API_URL}/sales/validate-token`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Falha ao validar token");
  }

  const result = await response.json();
  return result.data as ISaleOutputDTO;
}

export function useValidateSaleToken() {
  return useMutation({
    mutationFn: validateSaleToken,
    onSuccess: () => {
      toast.success("Token validado com sucesso!");
    },
  });
}
